import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { installRpcGuard, registerClerkTokenGetter } from "@/lib/rpcGuard";

// Installs the secure-rpc bridge and keeps it supplied with a live Clerk token
// getter so identity is always resolved server-side.
export const useRpcGuard = () => {
  const { getToken, isLoaded } = useAuth();

  useEffect(() => {
    installRpcGuard();
    registerClerkTokenGetter(getToken);
    return () => registerClerkTokenGetter(null);
  }, [getToken, isLoaded]);
};
